import * as React from 'react';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  required,
  DateField,
  ImageInput,
  ImageField,
  DeleteButton,
  DateInput,
  useTranslate,
  useLocaleState,
  useEditContext,
} from 'react-admin';

import EmptyList from '../components/misc/EmptyList';
import SourceLanguageBanner from '../components/form/SourceLanguageBanner';
import { useSourceLanguage } from '../hooks/useSourceLanguage';
import { RichTextInput } from 'ra-input-rich-text';

const entity = 'news';

export const NewsList = (props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const localeTitleKey = locale === 'tr' ? 'title.tr' : 'title.en';

  return (
    <List
      {...props}
      title={translate('news.title', { _: 'Haberler & Duyurular' })}
      empty={<EmptyList entity={entity} />}
    >
      <Datagrid>
        <TextField source={localeTitleKey} label={translate('news.news_title', { _: 'Başlık' })} />
        <DateField
          source="createdate"
          label={translate('news.created', { _: 'Oluşturulma Tarihi' })}
        />
        <DateField source="lastupdate" label={translate('news.updated', { _: 'Son Güncelleme' })} />
        <EditButton />
        <DeleteButton basePath={`/${entity}`} />
      </Datagrid>
    </List>
  );
};

const NewsFormFields = ({ isEdit = false, record }) => {
  const translate = useTranslate();
  const { localizedSource } = useSourceLanguage({ isEdit, record });

  return (
    <>
      <SourceLanguageBanner isEdit={isEdit} record={record} />
      <h3>{translate('venues.banner', { _: 'Haber Görseli' })}</h3>
      <ImageInput
        source="banner"
        label={translate('news.banner', { _: 'Haber Görseli' })}
        accept="image/*"
        defaultValue={null}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <h3>{translate('news.date', { _: 'Tarih' })}</h3>
      <DateInput
        source="date"
        label={translate('news.date', { _: 'Tarih' })}
        validate={required()}
        fullWidth
      />
      <h3>{translate('news.content', { _: 'İçerik' })}</h3>
      {!isEdit && (
        <TextInput
          source="slug"
          label={translate('venues.url_slug', { _: 'URL Bağlantısı (Slug)' })}
          fullWidth
        />
      )}
      <TextInput
        source={localizedSource('title')}
        label={translate('news.news_title', { _: 'Başlık' })}
        fullWidth
      />
      <TextInput
        source={localizedSource('subtitle')}
        label={translate('news.subtitle', { _: 'Alt Başlık' })}
        fullWidth
      />
      <RichTextInput
        source={localizedSource('content')}
        label={translate('news.content', { _: 'İçerik' })}
        validate={required()}
        fullWidth
      />
    </>
  );
};

const NewsEditForm = () => {
  const { record } = useEditContext();
  return (
    <SimpleForm redirect={`/${entity}`}>
      <NewsFormFields isEdit record={record} />
    </SimpleForm>
  );
};

export const NewsEdit = (props) => {
  const translate = useTranslate();
  return (
    <Edit
      title={translate('news.edit_news', { _: 'Haberi Düzenle' })}
      {...props}
      transform={(data, { previousData }) => ({
        ...data,
        sourceLang: previousData?.sourceLanguage || 'tr',
      })}
    >
      <NewsEditForm />
    </Edit>
  );
};

export const NewsCreate = (props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  return (
    <Create
      title={translate('news.new_news', { _: 'Yeni Haber' })}
      {...props}
      transform={(data) => ({
        ...data,
        sourceLang: locale || 'tr',
      })}
    >
      <SimpleForm redirect={`/${entity}`}>
        <NewsFormFields isEdit={false} />
      </SimpleForm>
    </Create>
  );
};
